module.exports = __webpack_public_path__ + "img/tram-gray.6d7be2eb.svg";